export const DEFAULT_TECHNICIAN_ROLES = [
  { role: "Record", status: false },
  { role: "Score", status: false },
];

const PAYMENT_ACCESS_FIELDS = [
  "recordCashRate",
  "recordSocialSecurityRate",
  "scoreCashRate",
  "scoreSocialSecurityRate",
];

const TECHNICIAN_EDIT_FIELDS = [
  "techId",
  "name",
  "fullname",
  "email",
  "tel",
  "node",
  "certificate",
  "status",
  "nickname",
  "team",
  "accessToken",
  "employmentType",
  "recordCashRate",
  "recordSocialSecurityRate",
  "scoreCashRate",
  "scoreSocialSecurityRate",
  "guaranteeCase",
  "splitNightTopupRate",
  "homeFirstCaseRate",
  "homeSecondCaseRate",
  "overnightFirstCaseRate",
  "overnightSecondCaseRate",
  "RPHFullnightFirstCaseRate",
  "RPHFullnightSecondCaseRate",
  "RPHSplitNightFirstCaseRate",
  "RPHSplitNightSecondCaseRate",
  "note",
];

const hasOwn = (object, key) =>
  Object.prototype.hasOwnProperty.call(object || {}, key);

const safeValue = (value, defaultValue = "") => {
  if (value === undefined || value === null) {
    return defaultValue;
  }

  return value;
};

export const normalizeTechnicianRoles = (roles) => {
  const rolesByName = Array.isArray(roles)
    ? roles.reduce((acc, item) => {
        if (item && item.role) {
          acc[item.role] = item;
        }
        return acc;
      }, {})
    : {};

  return DEFAULT_TECHNICIAN_ROLES.map((defaultRole) => ({
    ...defaultRole,
    status: rolesByName[defaultRole.role]
      ? rolesByName[defaultRole.role].status === true
      : defaultRole.status,
  }));
};

export const buildTechnicianUpdatePayload = ({
  item = {},
  inputValues = {},
  changedFields = {},
  checkedRoles,
  paymentAccess = false,
}) => {
  const getFieldValue = (fieldName) => {
    if (changedFields[fieldName]) {
      return safeValue(inputValues[fieldName]);
    }

    return safeValue(item[fieldName]);
  };

  return TECHNICIAN_EDIT_FIELDS.reduce(
    (payload, fieldName) => {
      if (!paymentAccess && PAYMENT_ACCESS_FIELDS.includes(fieldName)) {
        payload[fieldName] = safeValue(item[fieldName]);
      } else {
        payload[fieldName] = getFieldValue(fieldName);
      }

      return payload;
    },
    { roles: normalizeTechnicianRoles(checkedRoles || item.roles) },
  );
};

export const getTechnicianInitialValue = (item, fieldName) => {
  if (!fieldName || !hasOwn(item, fieldName)) {
    return "";
  }

  return safeValue(item[fieldName]);
};
